<template>
  <div :class="$style.wrapper">
    <BaseLoading
      v-if="isLoading"
      full-screen
    />
    <b-container>
      <b-row>
        <b-col
          :cols="12"
          class="text-center"
        >
          <BaseTextH1>
            {{ $t('now-is-your-chance-to-win-real-money') }}
          </BaseTextH1>
          <p class="pt-2">
            <span class="d-block">{{ $t('and-we-re-helping-you-jumpstart-your-luck-with-a') }}</span>
            <span :class="$style.orange">{{ $t('50tl-free-bet') }}</span>.
          </p>
          <p>{{ $t('21bet-text-1') }}</p>
        </b-col>
      </b-row>
      <b-row class="d-flex flex-column align-items-center pt-3">
        <b-col
          :cols="12"
          :sm="12"
          :md="10"
          :lg="8"
          :xl="6"
        >
          <BaseInput
            v-model="$v.username.$model"
            :form="$v.username"
            type="email"
            :class-name="$style.input"
            :label="$t('username')"
            @keyup.enter.native="handleRegisterSubmit"
          />

          <BaseInput
            v-model="$v.email.$model"
            :form="$v.email"
            type="email"
            :class-name="$style.input"
            :label="$t('email')"
            @keyup.enter.native="handleRegisterSubmit"
          />

          <BaseInput
            v-model="$v.password.$model"
            :form="$v.password"
            type="password"
            :class-name="$style.input"
            :label="$t('password')"
            @keyup.enter.native="handleRegisterSubmit"
          />

          <div class="d-flex d-flex justify-content-center py-3">
            <BaseButton
              is-rounded
              :variant="$v.$invalid ? 'outline-orange' : 'orange'"
              :class-name="$style.submit"
              @click="handleRegisterSubmit"
            >
              <span class="px-3">
                {{ $t('submit') }}
              </span>
            </BaseButton>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'
import BaseInput from '@/components/Atoms/Form/BaseInput'
import BaseButton from '@/components/Atoms/BaseButton'
import BaseLoading from '@/components/Atoms/BaseLoading'
import BaseTextH1 from '@/components/Atoms/Typography/BaseTextH1'

export default {
  components: {
    BaseTextH1,
    BaseLoading,
    BaseButton,
    BaseInput,
  },
  mixins: [validationMixin],
  props: {},
  metaInfo() {
    return {
      title: this.$t('page-titles.register'),
      meta: [
        { name: 'description', content: this.$t('page-descriptions.register') },
      ],
    }
  },
  data() {
    return {
      email: null,
      username: null,
      password: null,
      isLoading: false,
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
  created() {
    if (!['pick8001.com', 'www.pick8001.com'].includes(window.location.host)) {
      this.$router.push({
        name: 'home',
      })
    }
  },
  mounted() {
    if (this.user && this.user.email) {
      this.email = this.user.email
    }
  },
  methods: {
    ...mapActions({
      postRegister: 'auth/register/postBet21Register',
    }),
    handleRegisterSubmit() {
      this.$v.$touch()
      if (!this.$v.$anyError) {
        this.isLoading = true
        this.postRegister({
          username: this.username,
          email: this.email,
          password: this.password,
        }).then((res) => {
          if (res && res.url) {
            if (process.env.VUE_APP_GTAG_ID && typeof dataLayer !== 'undefined') {
              // eslint-disable-next-line no-undef
              dataLayer.push({
                'event': '212bet_oneclick',
                'category': '21bet',
                'label': 'oneclick',
              })
            }
            window.location.href = res.url
          } else {
            this.isLoading = false
          }
        })
      }
    },
  },
  validations: {
    username: {
      required,
    },
    email: {
      required,
      email,
    },
    password: {
      required,
      minLength: minLength(6),
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../../assets/scss/variables";
  .orange {
    color: $color-tomato;
    font-weight: 600;
  }
</style>
